import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
import { ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import trTR from 'antd/locale/tr_TR';
const container = document.getElementById('root');

if (!container) {
  throw new Error("Root konteyneri bulunamadı.");
}
const root = ReactDOM.createRoot(container);

root.render(
  <Provider store={store}>
    <ConfigProvider theme={{ token: { colorPrimary: '#00861a' } }} locale={trTR}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </Provider>
);